<template>
  <div class="yxtbiz-signup-info">
    <div class="fs16 fw500 c-cC26 mb24">{{language().tit_applicant}}</div>
    <div class="mb24 h22">
      <div class="fs14 c-cC8C pull-left w50p-12">
        {{language().lbl_name}}：
        <span class="c-cC26">
          <yxtbiz-user-name :name="data.fullname || '--'" />（{{data.username || '--'}}）
        </span>
      </div>
      <div class="fs14 c-cC8C pull-right w50p-12">
        {{language().lbl_department}}：
        <span class="c-cC26">
          <yxtbiz-dept-name :name="data.deptName || '--'" />
        </span>
      </div>
    </div>
    <div class="mb36 h22">
      <div class="fs14 c-cC8C pull-left w50p-12">{{language().lbl_position_name}}：<span class="c-cC26"><yxtbiz-position-name :name="data.positionNameList || '--'" /></span></div>
    </div>
    <template v-if="data.surveyProjectAnswerUrl">
      <div class="fs16 fw500 c-cC26 mb24">{{language().tit_check}}</div>
      <div class="fs14 mb36">
        <div class="relative h40 pl40 bc-cCF5 rtl4 rtr4 rbl4 rbr4">
          <img class="absolute wh24 left12 top8" :src="`${$staticBaseUrl}assets/862f0624/fba17c0a/investigate.svg`">
          <span class="c-cC26 ellipsis w148-max inline-block relative top9">{{data.surveyTemplateName}}</span>
          <yxt-button class="pull-right relative top8 right12" size="small" plain @click.stop="toSurvey">{{language().btn_see_check}}</yxt-button>
        </div>
      </div>
    </template>
    <template v-if="data.attachments && data.attachments.length">
      <div class="fs16 fw500 c-cC26 mb24">{{language().tit_attach}}</div>
      <div class="fs14 mb36">
        <div v-for="(item, index) in data.attachments" :key="index" :class="`inline-block ${index % 2 === 0 ? '' : 'ml24'} border-box relative mb4 w50p-12 h40 pl40 bc-cCF5-hover rtl4 rtr4 rbl4 rbr4`" @click="downloadFunc(item)">
          <img class="absolute wh20 left14 top10" :src="getIconName(item.fileClass)">
          <span class="c-cC26 ellipsis w148-max inline-block relative top9" :title="item.name && item.name.replace(/\.[^.]+$/, '')">{{item.name && item.name.replace(/\.[^.]+$/, '')}}</span>
          <span class="c-cC26 inline-block relative top3">.{{item.name && item.name.split('.').pop()}}</span>
          <span class="c-cC8C fs12 ml8 relative top2">{{getSize(item.size)}}</span>
          <img class="x-close c-cC26-hover c-cC8C wh18 pointer absolute top11 right12" :src="`${$staticBaseUrl}assets/259cb717/547f3640/%E8%B7%AF%E5%BE%84%202.svg`" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'YxtbizSignupInfo',
  inject: ['language'],
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      data: {}
    };
  },
  methods: {
    // 文件图标
    getIconName(type) {
      return {
        word: `${this.$staticBaseUrl}assets/862f0624/7c0f9d3d/word.svg`,
        excel: `${this.$staticBaseUrl}assets/862f0624/7901cbdd/excel.svg`,
        ppt: `${this.$staticBaseUrl}assets/862f0624/66820d8b/ppt.svg`,
        pdf: `${this.$staticBaseUrl}assets/862f0624/326d0e0e/pdf.svg`,
        img: `${this.$staticBaseUrl}assets/862f0624/e866558c/img.svg`,
        video: `${this.$staticBaseUrl}assets/862f0624/5a1c3fd0/video.svg`,
        audio: `${this.$staticBaseUrl}assets/862f0624/77f30b62/audio.svg`,
        zip: `${this.$staticBaseUrl}assets/862f0624/5b213907/zip.svg`
      }[type] || `${this.$staticBaseUrl}assets/862f0624/12a90e74/third.svg`;
    },
    // 获取大小
    getSize(size) {
      if (!size) {
        return '0 B';
      }
      if (size < 1024) {
        return size.toFixed() + ' B';
      }
      size = size / 1024;
      if (size < 1024) {
        return size.toFixed() + ' K';
      }
      size = size / 1024;
      if (size < 1024) {
        return size.toFixed() + ' M';
      }
      size = size / 1024;
      return size.toFixed() + ' G';
    },
    // 查看问卷
    toSurvey() {
      window.open(this.data.surveyProjectAnswerUrl);
    },
    // 下载文件
    async downloadFunc(file) {
      const SDK = this.$parent.SDK;
      const url = await SDK.download(file.fileId);
      this.$parent.fmessage(url, fileUrl => {
        window.location.href = fileUrl;
      });
    }
  },
  async created() {
    const SDK = this.$parent.SDK;
    this.data = await SDK.getRecordDetail(this.id);
    this.$parent.fmessage(this.data);
    this.$emit('callback', this.data.appProjectId, this.data);
  }
};
</script>
